var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuQuizTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 542,
    height: 327,
    viewBox: "0 0 542 327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4196ea;font-size:121px;}.a,.b{font-family:Montserrat-ExtraBold, Montserrat;font-weight:800;}.b{fill:#fff;font-size:205px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-693 -156)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(960 273)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -266.14,
    y: 0
  }, "EU QUIZ")), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(968 432)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -266.5,
    y: 0
  }, "TIME")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuQuizTime);
export default __webpack_public_path__ + "static/media/eu-quiz-time.67b8691e.svg";
export { ForwardRef as ReactComponent };